export function isNonEmptyArray(arr) {
  return Boolean(arr === null || arr === void 0 ? void 0 : arr.length);
}